/**
 * Module Staff #13 — Rapports & exports avancés
 */
const moduleStaffRapports = {
  id: 'staff-rapports',
  population: 'staff',
  order: 13,
  category: 'Pilotage',
  title: 'Rapports & exports avancés',
  subtitle: 'Construire des rapports custom et automatiser leur envoi',
  icon: 'BarChart3',
  duration: '20 min',
  level: 'Intermédiaire',
  slides: [
    { type: 'cover', eyebrow: 'Module 13 — Staff', title: 'Rapports & exports', subtitle: 'Reporting interne et CFO automatisé', icon: 'BarChart3', duration: '20 min', audience: 'Direction & contrôle', level: 'Intermédiaire' },
    { type: 'intro', title: 'Objectifs', intro: 'Le module Rapports permet de construire vos propres KPIs et d\'automatiser leur diffusion.', objectives: [
      'Comprendre les 10+ templates internes disponibles',
      'Créer un rapport personnalisé avec drill-down',
      'Programmer un envoi automatique (hebdo/mensuel)',
      'Exporter en CSV/PDF/Excel',
      'Sécuriser les rapports sensibles (RBAC)',
    ]},
    { type: 'concept', eyebrow: 'Catalogue', icon: 'BookOpen', title: 'Les rapports internes natifs',
      bullets: [
        '💰 CFO hebdomadaire : envoi auto lundi 8h, KPIs + objectifs',
        '🚛 Activité opérationnelle : volume, ponctualité, incidents',
        '👥 Performance commerciale : conversion, marges, top deals',
        '⭐ Customer Success : NPS, churn, alertes Détracteurs',
        '🛡️ Audit RBAC : qui a fait quoi (compliance OHADA + RGPD)',
      ],
      note: 'Tous les rapports natifs peuvent être dupliqués et personnalisés.',
    },
    { type: 'steps', title: 'Créer un rapport custom', steps: [
      { title: 'Page Rapports → "+ Nouveau"', detail: 'Bouton vert.' },
      { title: 'Choisir un template ou vierge', detail: 'Vierge = liberté totale.' },
      { title: 'Drag & drop des KPIs', detail: 'Glisser depuis la palette à droite.' },
      { title: 'Définir filtres et période', detail: 'Multi-critères supportés.' },
      { title: 'Programmer l\'envoi (optionnel)', detail: 'Destinataires + fréquence + format.' },
      { title: 'Sauvegarder', detail: 'Rapport disponible dans "Mes rapports".' },
    ]},
    { type: 'comparison', title: 'Reporting : best practices', do: [
      'Cibler 5-7 KPIs clés (pas 30)',
      'Automatiser les rapports récurrents',
      'PDF pour direction, CSV pour analyse',
      'Restreindre les rapports sensibles (RBAC)',
    ], dont: [
      'Pas de rapport pour le rapport (utilité ?)',
      'Pas d\'envoi à toute l\'entreprise (RGPD)',
      'Pas de KPIs sans contexte',
      'Pas d\'export Excel avec données nominatives sans accord',
    ]},
    { type: 'quiz', title: 'Quiz',
      question: 'Vous voulez envoyer un rapport CFO hebdo à la direction tous les lundis 8h. Comment ?',
      options: [
        'Exporter manuellement chaque semaine',
        'Demander à l\'IT de faire un script',
        'Créer le rapport + configurer "Envoi programmé" → Lundi 8h, destinataires email',
        'Faire un cron',
      ],
      answerIndex: 2,
      explanation: 'L\'envoi programmé natif automatise tout. Vous gagnez 1 h/semaine et la direction reçoit sans rappel.',
    },
    { type: 'takeaways', title: 'À retenir', items: [
      '10+ templates natifs prêts à l\'emploi.',
      'Custom = drag & drop KPIs.',
      'Envoi programmé = automatisation totale.',
      'RBAC = sécurité rapports sensibles.',
    ]},
    { type: 'cta', title: 'Module 13 terminé !', actions: [
      { label: 'Page Rapports', href: '/admin/reports' },
      { label: 'Catalogue', href: '/docs/admin/training' },
    ]},
  ],
};
export default moduleStaffRapports;
